import React from "react";
import "./terms.css";

import logoWhite from './logo_white.png';

const PrivacyPolicy = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top px-3">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img
              src={logoWhite}
              alt="KeyConnect Logo"
              style={{ height: "40px", marginLeft: "20px" }}
            />
          </a>
        </div>
      </nav>

      <section className="legal-page">
        <div className="wrap">
          <h1>Privacy Policy</h1>

          <div className="legal-meta">
            <div>
              <strong>Effective Date:</strong> 8<sup>th</sup> July 2025
            </div>
            <div>
              <strong>Website:</strong>{" "}
              <a
                href="https://www.keyconnect.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.keyconnect.in
              </a>
            </div>
            <div>
              <strong>Platform:</strong> KeyConnect CRM
            </div>
          </div>

          <p>
            Welcome to <strong>KeyConnect CRM</strong> ("we", "our", "us").
            This Privacy Policy outlines how we collect, use, store, and
            protect your personal and business information when you visit or
            use our website or platform located at{" "}
            <a
              href="https://www.keyconnect.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.keyconnect.in
            </a>{" "}
            ("Website").
          </p>

          <p>
            By accessing or using our services, you agree to the terms of
            this Privacy Policy.
          </p>

          <section>
            <h2>1. Information We Collect</h2>
            <p>
              <strong>Information You Provide</strong>
            </p>
            <ul>
              <li>Contact details (name, email, phone number, business name)</li>
              <li>Account login credentials</li>
              <li>Billing and payment information</li>
              <li>Content submitted through forms or support requests</li>
            </ul>

            <p>
              <strong>Automatically Collected Data</strong>
            </p>
            <ul>
              <li>IP address and browser type</li>
              <li>Device identifiers</li>
              <li>Date/time of visit</li>
              <li>Pages visited and time spent</li>
              <li>Cookies and similar tracking technologies (see Section 6)</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <ul>
              <li>Provide access to the KeyConnect CRM platform</li>
              <li>Manage your account and billing</li>
              <li>Improve platform functionality and user experience</li>
              <li>Communicate updates, announcements, or service alerts</li>
              <li>Respond to inquiries and provide technical support</li>
              <li>Ensure platform security and detect fraudulent activities</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2>3. Information Sharing &amp; Disclosure</h2>
            <p>
              We do <strong>not sell or rent</strong> your personal
              information.
            </p>
            <p>We may share data only with:</p>
            <ul>
              <li>Our internal team, subsidiaries, or authorized service partners</li>
              <li>
                Trusted third-party service providers (e.g., hosting,
                payment processors, communication APIs) under strict
                confidentiality
              </li>
              <li>
                Authorities, when required by applicable law, regulation,
                legal process, or governmental request
              </li>
            </ul>
          </section>

          <section>
            <h2>4. Data Security</h2>
            <p>We employ industry-standard security practices, including:</p>
            <ul>
              <li>Encryption of data at rest and in transit</li>
              <li>Access control mechanisms</li>
              <li>Firewalls and threat detection</li>
              <li>Regular data backups</li>
            </ul>
          </section>

          <section>
            <h2>5. Data Retention</h2>
            <p>We retain your data:</p>
            <ul>
              <li>As long as your account is active</li>
              <li>
                For a reasonable period thereafter for legal, operational, or
                dispute resolution purposes
              </li>
            </ul>
            <p>
              You may request data deletion by writing to:{" "}
              <a href="mailto:support@keyconnect.in">support@keyconnect.in</a>
            </p>
          </section>

          <section>
            <h2>6. Cookies and Tracking</h2>
            <p>We use cookies and similar technologies to:</p>
            <ul>
              <li>Maintain session states</li>
              <li>Remember your preferences</li>
              <li>Analyse website usage to improve performance</li>
            </ul>
            <p>
              You can control or disable cookies via your browser settings,
              though some features may become unavailable.
            </p>
          </section>

          <section>
            <h2>7. Third-Party Links</h2>
            <p>
              Our website may contain links to third-party platforms. We are
              not responsible for the privacy practices or content of these
              websites. We encourage you to review their privacy policies
              separately.
            </p>
          </section>

          <section>
            <h2>8. Your Rights</h2>
            <p>Depending on your location, you may have rights to:</p>
            <ul>
              <li>Request to delete your personal data</li>
              <li>Object to or restrict processing</li>
              <li>Withdraw consent (where applicable)</li>
            </ul>
            <p>
              To exercise these rights, please contact us at:{" "}
              <a href="mailto:support@keyconnect.in">support@keyconnect.in</a>
            </p>
          </section>

          <section>
            <h2>9. Children's Privacy</h2>
            <p>
              Our services are intended for business use and not directed
              toward children under the age of 16. We do not knowingly
              collect data from minors.
            </p>
          </section>

          <section>
            <h2>10. Changes to This Policy</h2>
            <p>
              We reserve the right to update this Privacy Policy at any
              time. Changes will be posted on this page with a revised
              effective date. Your continued use of the Website constitutes
              your agreement to the updated terms.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              <strong>Privacy Officer</strong>
              <br />
              KeyConnect CRM
              <br />
              Email:{" "}
              <a href="mailto:support@keyconnect.in">support@keyconnect.in</a>
              <br />
              Website:{" "}
              <a
                href="https://www.keyconnect.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.keyconnect.in
              </a>
            </p>
          </section>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-dark text-light text-center py-4">
        <small>
          &copy; {new Date().getFullYear()} KeyConnect CRM. All rights reserved.
        </small>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;